import { searchBox as searchBoxWidget } from "instantsearch.js/es/widgets";
let timerId;
const results = document.querySelector('[data-ttecsolutions-results]')
const keyStrokeTimeout = 650;
let searchLoading = false;

export const ttecSolutionsSearchBox = searchBoxWidget({
  container: '[data-ttecsolutions-search-box]',
  placeholder: 'Search Solutions...',
    queryHook(query, refine) {
      startSearch();
      clearTimeout(timerId);
      timerId = setTimeout(() => {refine(query); endSearch()}, keyStrokeTimeout);
  },
  showReset: true,
  showSubmit: false,
  cssClasses: {
    input: [
      "js-ttecsolutions-search-input relative text-base hover:cursor-text outline-none focus:border-blue w-full block bg-gray-50 border border-gray-300 placeholder-black p-3 leading-normal rounded-sm pl-10 focus:placeholder-transparent"
    ],
    reset: [
      // hidden, but shows when form is focused because of class set in forms.css
      'h-full w-8 flex items-center justify-center absolute top-0 right-0 focus:ring-1 opacity-0' 
    ],
    resetIcon: [
      ''
    ]
  }
})

function startSearch() {
  if(!searchLoading) {
    results.classList.add('opacity-50')
  }
  searchLoading = true;
}

function endSearch() {
  if(searchLoading) {
    results.classList.remove('opacity-50')
  }
  searchLoading = false;
}
